import { useMemo } from 'react'
import { getAppSettings } from 'services/settings'
import { appSettingsKey } from 'utils/constants/queryKey'
import { AppSettings, GetAppSettingsResponse } from 'services/types/settings'
import { STALE_TIME } from 'utils/constants'

import { AppQueryOptions, useAppQueryMap } from './use-app-query'
import useUser from './use-user'

const parseAppSettings = (type: GetAppSettingsResponse['type'], value: GetAppSettingsResponse['value']) => {
  try {
    switch (type) {
      case 'BOOLEAN':
        return value === 'true'
      case 'JSON':
        return JSON.parse(value)
      case 'NUMERIC':
        return Number(value)
      default:
        return value
    }
  } catch (e) {
    return value
  }
}

const mapAppSettings = (data: GetAppSettingsResponse[]) => {
  const appSettings: Partial<AppSettings> = {}

  data.forEach((item: GetAppSettingsResponse) => {
    appSettings[item.id] = parseAppSettings(item.type, item.value)
  })

  return appSettings
}

const useAppSetting = (queryOptions?: AppQueryOptions) => {
  const { currentUser, currentBranch } = useUser()

  const token = localStorage.getItem('token')

  const { masterId, branchId, hasToken } = useMemo(() => {
    //Logged in
    if (!!currentUser.master?.id && !!currentBranch?.branchId && !!token) {
      return {
        masterId: currentUser.master.id,
        branchId: currentBranch.branchId,
        hasToken: true,
      }
    }
    return {
      masterId: undefined,
      branchId: undefined,
      hasToken: false,
    }
  }, [currentUser.master?.id, currentBranch?.branchId, token])

  const { data, ...rest } = useAppQueryMap(
    appSettingsKey.detail({
      master_id: masterId ?? '',
      branch_id: branchId ?? '',
      token: hasToken,
    }),
    () => getAppSettings({ master_id: masterId }),
    mapAppSettings,
    {
      staleTime: STALE_TIME.branchSetting,
      ...queryOptions,
    },
  )

  return { key: data ?? {}, ...rest }
}

export default useAppSetting
